module.exports = {
      id: "how-to-play-usage",
      viewBox: "0 0 296 296",
      url: __webpack_public_path__ + "svg-sprite-f2ca7f9d4080f6eed262da64a41d98e9.svg#how-to-play",
      toString: function () {
        return this.url;
      }
    }